import swal from "sweetalert";

export const showDeficitAlert = (deficitItems = [], module = "unknown") => {
  const wrapper = document.createElement("div");

  wrapper.innerHTML = `
    <p style="margin-bottom: 12px; font-size: 14px; text-align: center; color: #333;">
      Cannot approve this ${module}. The following items exceed available warehouse stock:
    </p>
    <div style="max-height: 220px; overflow-y: auto; border: 1px solid #ddd; border-radius: 4px;">
      <table style="width: 100%; border-collapse: collapse; font-size: 13px;">
        <thead>
          <tr>
            <th style="position: sticky; top: 0; z-index: 1; background-color: #fff; color: #333; padding: 9px 12px; text-align: left; border-bottom: 2px solid #ccc; font-weight: 600;">
              Product Name
            </th>
            <th style="position: sticky; top: 0; z-index: 1; background-color: #fff; color: #333; padding: 9px 12px; text-align: center; border-bottom: 2px solid #ccc; font-weight: 600;">
              Required Stocks
            </th>
            <th style="position: sticky; top: 0; z-index: 1; background-color: #fff; color: #333; padding: 9px 12px; text-align: center; border-bottom: 2px solid #ccc; font-weight: 600;">
              Available Stocks
            </th>
            <th style="position: sticky; top: 0; z-index: 1; background-color: #fff; color: #333; padding: 9px 12px; text-align: center; border-bottom: 2px solid #ccc; font-weight: 600;">
              Remaining Deficit
            </th>
          </tr>
        </thead>
        <tbody>
          ${deficitItems
            .map(
              (item, index) => `
            <tr style="background-color: ${index % 2 === 0 ? "#ffffff" : "#f9f9f9"};">
              <td style="padding: 8px 12px; border-bottom: 1px solid #eee; color: #444; text-align: left;">
                ${item.product_name || "Unknown Product"}
              </td>
              <td style="padding: 8px 12px; border-bottom: 1px solid #eee; color: #e53e3e; font-weight: bold; text-align: center;">
                ${item.deficit}
              </td>
              <td style="padding: 8px 12px; border-bottom: 1px solid #eee; color: #d97706; font-weight: bold; text-align: center;">
                ${item.available_stock}
              </td>
              <td style="padding: 8px 12px; border-bottom: 1px solid #eee; color: #e53e3e; font-weight: bold; text-align: center;">
                ${item.remaining_deficit}
              </td>
            </tr>`,
            )
            .join("")}
        </tbody>
      </table>
    </div>
    <p style="margin-top: 12px; font-size: 13px; color: #888; text-align: center;">
      Please add the required stocks and try again.
    </p>
  `;

  swal({
    icon: "error",
    title: "Insufficient Stock",
    content: wrapper,
  });

  setTimeout(() => {
    const modal = document.querySelector(".swal-modal");
    if (modal) {
      modal.style.maxHeight = "90vh";
      modal.style.maxWidth = "600px";
      modal.style.width = "100%";
      modal.style.overflowY = "auto";
    }
  }, 0);
};
